const tipoCarteiraInvestimentoList = [
    {
        id: 'C',
        descricao: 'Conservadora',
        tipoArquivo: 90,
        ordem: 10,
    },
    {
        id: 'M',
        descricao: 'Moderada',
        tipoArquivo: 100,
        ordem: 20,
    },
    {
        id: 'A',
        descricao: 'Arrojada',
        tipoArquivo: 110,
        ordem: 30,
    },
]

export default tipoCarteiraInvestimentoList